const CartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 6.51011C15.75 4.31676 13.8655 2.55996 11.6324 2.77661L11.6297 2.77687C9.80824 2.94687 8.25 4.79256 8.25 6.70011V7.67011C8.25 8.08433 7.91421 8.42011 7.5 8.42011C7.08579 8.42011 6.75 8.08433 6.75 7.67011V6.70011C6.75 4.10811 8.81106 1.53423 11.4889 1.28348C14.6152 0.980976 17.25 3.44391 17.25 6.51011V7.89011C17.25 8.30433 16.9142 8.64011 16.5 8.64011C16.0858 8.64011 15.75 8.30433 15.75 7.89011V6.51011Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.37437 8.81723C4.25978 7.76457 5.77779 7.25 8.00083 7.25H16.0008C18.2239 7.25 19.7419 7.76457 20.6273 8.81723C21.5056 9.8614 21.5878 11.2337 21.4463 12.5125L21.4451 12.523L20.6958 18.5167C20.5853 19.5429 20.3264 20.6669 19.4104 21.5037C18.4993 22.3361 17.0877 22.75 15.0008 22.75H9.00083C6.91398 22.75 5.50236 22.3361 4.59121 21.5037C3.67527 20.6669 3.41637 19.5429 3.30581 18.5166L2.5553 12.5125C2.4138 11.2337 2.49609 9.8614 3.37437 8.81723ZM4.04571 12.3423L4.79668 18.3501C4.89652 19.282 5.10338 19.9399 5.60294 20.3963C6.1093 20.8589 7.06768 21.25 9.00083 21.25H15.0008C16.934 21.25 17.8924 20.8589 18.3987 20.3963C18.8983 19.9399 19.1052 19.282 19.2051 18.3501L19.2065 18.337L19.956 12.3422C20.0835 11.1837 19.9504 10.3428 19.4794 9.78277C19.0148 9.23043 18.0478 8.75 16.0008 8.75H8.00083C5.95386 8.75 4.98688 9.23043 4.52229 9.78277C4.05126 10.3428 3.91818 11.1838 4.04571 12.3423Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4961 12C14.4961 11.4477 14.9438 11 15.4961 11H15.5051C16.0574 11 16.5051 11.4477 16.5051 12C16.5051 12.5523 16.0574 13 15.5051 13H15.4961C14.9438 13 14.4961 12.5523 14.4961 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49609 12C7.49609 11.4477 7.94381 11 8.49609 11H8.50508C9.05736 11 9.50508 11.4477 9.50508 12C9.50508 12.5523 9.05736 13 8.50508 13H8.49609C7.94381 13 7.49609 12.5523 7.49609 12Z"
      fill="currentColor"
    />
  </svg>
);

export default CartIcon;
